import { motion } from "framer-motion";

import { ANIMATION_DURATION } from "@/constants/animations.constants";
import { Spinner } from "atoms/Spinner";

export interface AccountSetupLoadingProps {
  message?: string;
}

export const AccountSetupLoading = ({
  message = "Setting up your account...",
}: AccountSetupLoadingProps) => {
  return (
    <motion.div
      className="mt-10 flex flex-col items-center justify-center gap-6"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: ANIMATION_DURATION }}
    >
      <Spinner />
      <motion.div
        className="text-body2 text-secondary"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: ANIMATION_DURATION, delay: 0.2 }}
      >
        {message}
      </motion.div>
    </motion.div>
  );
};

export default AccountSetupLoading;
